'use strict';

var jsUtils = require('@swiggy-private/js-utils');

const ACCESSIBILITY_TEXTS = {
    MEDIUMSPICY: "MEDIUMSPICY",
    MEDIUM_SPICY: "Spice level: Medium spicy ",
    VERY_SPICY: "Spice level: Very spicy ",
    TAGS_FOR_THIS_ITEM_ARE: "Tags for this item are: ",
    NUTRITIONAL_DETAILS_FOR_THIS_ITEM_ARE: "Nutritional details for this item are: ",
    VEG_ITEM: "Veg Item. ",
    NON_VEG_ITEM: "Non-veg item. ",
    ITEM_NAME: "{0}. ",
    RIBBON_TEXT: "This item is a {0}, ",
    ITEM_SPICE_LEVEL: "{0}, ",
    COSTS: "Costs: {0} rupees, ",
    ITEM_OFFER: "Offer: Get {0}; {1}, ",
    DESCRIPTION: "Description: {0} ",
    HEALTHY_ITEM_DESCRIPTION: "Description: ",
    ITEM_IS_CUSTOMIZABLE: "This item is customizable. ",
    ZERO: "0",
    FULL_STOP: ".",
    COMMA: ", ",
    EMPTY_STRING: "",
    SKIP_TO_VIEW_CART_BTN: "Skip to view cart button",
    SWIPE_RIGHT_TO_ADD_ITEM: "Swipe right to add item to cart.",
};
const TEXTS = {
    GRAMS: "grams",
    KILOGRAM: "kilogram",
    PIECES: "pieces",
    KILO_CALORIES: "kilo calories",
    MORE_DETAILS: "More Details",
};
const OVERLAY_HELPER_TEXT = "See more information about";
const COLOR_PALETTE = ["#fbeed7", "#e5f1d3", "#e0eef5", "#f6e6e9"];
const OVERLAY_IMAGE_SIZE = 340;
const DESC_COLLAPSE_LENGTH = 80;
const FULL_DESC_COLLAPSE_LENGTH = 108;
const DESC_COLLAPSE_LENGTH_DWEB = 150;
const FULL_DESC_COLLAPSE_LENGTH_DWEB = 200;
const DESC_EXP_TEXT = "more";
const ITEM_DESCRIPTION_HEADING_TEXT = "Item Details :";
const INGREDIENT_HEADING_TEXT = "Ingredients :";

const getDescriptionLength = (hasImage, isDweb) => {
    if (hasImage) {
        return isDweb ? DESC_COLLAPSE_LENGTH_DWEB : DESC_COLLAPSE_LENGTH;
    }
    return isDweb ? FULL_DESC_COLLAPSE_LENGTH_DWEB : FULL_DESC_COLLAPSE_LENGTH;
};
function possiblePrecision(num) {
    if (num % 1 !== 0) {
        return num.toFixed(2);
    }
    else {
        return num.toFixed(0);
    }
}
function inRupee(value, divideByHundred) {
    if (divideByHundred) {
        return possiblePrecision(value / 100);
    }
    return possiblePrecision(value);
}
function showFinalPrice(price, finalPrice) {
    return +price > 0 && price !== finalPrice;
}
const getNormalItemLabel = ({ name, description = "", finalPrice, price, vegType, ribbon, offerTags, customizable, bulletPoints, itemInfoTags, specialCategoryTag, }) => {
    var _a;
    const normalItemDetails = {
        itemName: name,
        vegType,
        price,
        finalPrice,
        description,
        isCustomizable: customizable,
        offer: offerTags ? offerTags[0] : undefined,
        ribbon,
    };
    const normalItemPrice = (itemPrice, itemFinalPrice) => {
        if (itemFinalPrice !== undefined) {
            return possiblePrecision(itemFinalPrice / 100).toString();
        }
        else if (itemPrice !== undefined) {
            return possiblePrecision(itemPrice / 100).toString();
        }
        else {
            return ACCESSIBILITY_TEXTS.ZERO;
        }
    };
    const getHealthyItemTags = (healthyItemTags) => {
        if (healthyItemTags && healthyItemTags.length > 0) {
            let tagLabel = ACCESSIBILITY_TEXTS.TAGS_FOR_THIS_ITEM_ARE;
            healthyItemTags.map((tag) => {
                tagLabel += tag.text + ACCESSIBILITY_TEXTS.COMMA;
            });
            return tagLabel;
        }
        return ACCESSIBILITY_TEXTS.EMPTY_STRING;
    };
    const getHealthyItemNutritions = (nutritionsList) => {
        if (nutritionsList && nutritionsList.length > 0) {
            let nutritionLabelString = ACCESSIBILITY_TEXTS.NUTRITIONAL_DETAILS_FOR_THIS_ITEM_ARE;
            const NUTRITIONAL_ITEM_LABEL = "{0} {1}, ";
            nutritionsList.map((nutritionalItem) => {
                nutritionLabelString += jsUtils.format(NUTRITIONAL_ITEM_LABEL, nutritionalItem.subtitle, nutritionalItem.title);
            });
            return nutritionLabelString;
        }
        return ACCESSIBILITY_TEXTS.EMPTY_STRING;
    };
    const getHealthyItemDescription = (bullets) => {
        if (bullets && bullets.length > 0) {
            let descriptionLabel = ACCESSIBILITY_TEXTS.DESCRIPTION;
            bullets.map((bullet) => {
                descriptionLabel += bullet.title + ACCESSIBILITY_TEXTS.COMMA;
            });
            return descriptionLabel;
        }
        return ACCESSIBILITY_TEXTS.EMPTY_STRING;
    };
    const VEG_TYPE = normalItemDetails.vegType == 1
        ? ACCESSIBILITY_TEXTS.VEG_ITEM
        : ACCESSIBILITY_TEXTS.NON_VEG_ITEM;
    const ITEM_NAME = jsUtils.format(ACCESSIBILITY_TEXTS.ITEM_NAME, normalItemDetails.itemName);
    const RIBBON_TEXT = ((_a = normalItemDetails.ribbon) === null || _a === void 0 ? void 0 : _a.text)
        ? jsUtils.format(ACCESSIBILITY_TEXTS.RIBBON_TEXT, normalItemDetails.ribbon.text)
        : ACCESSIBILITY_TEXTS.EMPTY_STRING;
    const ITEM_COST = jsUtils.format(ACCESSIBILITY_TEXTS.COSTS, normalItemPrice(normalItemDetails.price, normalItemDetails.finalPrice));
    const HEALTHY_ITEM_LABEL = getHealthyItemTags(specialCategoryTag);
    const HEALTHY_ITEM_NUTRITION_LABEL = getHealthyItemNutritions(itemInfoTags);
    const ITEM_OFFER_STRING = normalItemDetails.offer !== undefined
        ? jsUtils.format(ACCESSIBILITY_TEXTS.ITEM_OFFER, normalItemDetails.offer.title, normalItemDetails.offer.subTitle)
        : ACCESSIBILITY_TEXTS.EMPTY_STRING;
    const ITEM_DESCRIPTION = normalItemDetails.description
        ? jsUtils.format(ACCESSIBILITY_TEXTS.DESCRIPTION, normalItemDetails.description)
        : ACCESSIBILITY_TEXTS.EMPTY_STRING;
    const HEALTHY_ITEM_DESCRIPTION = getHealthyItemDescription(bulletPoints);
    const CUSTOMIZABLE_STRING = normalItemDetails.isCustomizable == true
        ? ACCESSIBILITY_TEXTS.ITEM_IS_CUSTOMIZABLE
        : ACCESSIBILITY_TEXTS.EMPTY_STRING;
    const SWIPE_RIGHT_TO_ADD_ITEM = ACCESSIBILITY_TEXTS.SWIPE_RIGHT_TO_ADD_ITEM;
    return (VEG_TYPE +
        ITEM_NAME +
        RIBBON_TEXT +
        ITEM_COST +
        HEALTHY_ITEM_LABEL +
        HEALTHY_ITEM_NUTRITION_LABEL +
        ITEM_OFFER_STRING +
        ITEM_DESCRIPTION +
        HEALTHY_ITEM_DESCRIPTION +
        CUSTOMIZABLE_STRING +
        SWIPE_RIGHT_TO_ADD_ITEM);
};

exports.ACCESSIBILITY_TEXTS = ACCESSIBILITY_TEXTS;
exports.COLOR_PALETTE = COLOR_PALETTE;
exports.DESC_EXP_TEXT = DESC_EXP_TEXT;
exports.INGREDIENT_HEADING_TEXT = INGREDIENT_HEADING_TEXT;
exports.ITEM_DESCRIPTION_HEADING_TEXT = ITEM_DESCRIPTION_HEADING_TEXT;
exports.OVERLAY_HELPER_TEXT = OVERLAY_HELPER_TEXT;
exports.OVERLAY_IMAGE_SIZE = OVERLAY_IMAGE_SIZE;
exports.TEXTS = TEXTS;
exports.getDescriptionLength = getDescriptionLength;
exports.getNormalItemLabel = getNormalItemLabel;
exports.inRupee = inRupee;
exports.possiblePrecision = possiblePrecision;
exports.showFinalPrice = showFinalPrice;
//# sourceMappingURL=index-2bhV6eMA.js.map
